import { getLenis } from './lenis';

export class Sidebar {
    static scrollLockCount = 0;

    static lockPageScroll() {
        if (Sidebar.scrollLockCount === 0) {
            document.documentElement.classList.add('overflow-hidden');
            document.body.classList.add('overflow-hidden');
            getLenis()?.stop();
        }

        Sidebar.scrollLockCount += 1;
    }

    static unlockPageScroll() {
        Sidebar.scrollLockCount = Math.max(0, Sidebar.scrollLockCount - 1);

        if (Sidebar.scrollLockCount === 0) {
            document.documentElement.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden');
            getLenis()?.start();
        }
    }

    constructor(options = {}) {
        this.options = {
            lockScroll: true,
            ...options,
        };
        this.init();
    }

    init() {
        this.root = null;
        this.content = null;
        this.overlay = null;

        this.create();
        this.events();
    }

    create = () => {
        const rootClassNames = [
            'fixed',
            'top-0',
            'left-0',
            'w-full',
            'h-full',
            'z-200',
            'pointer-events-none',
            'group',
            '[&.-active]:pointer-events-auto',
            ...(this.options.rootClassNames || []),
        ];

        this.root = document.createElement('div');
        this.root.classList.add(...rootClassNames);

        const overlayClassNames = [
            'absolute',
            'top-0',
            'left-0',
            'w-full',
            'h-full',
            'z-10',
            'bg-grey-900/30',
            'cursor-pointer',
            'opacity-0',
            'group-[.-active]:opacity-100',
            'transition-all',
            ...(this.options.overlayClassNames || []),
        ];

        this.overlay = document.createElement('div');
        this.overlay.classList.add(...overlayClassNames);
        this.root.appendChild(this.overlay);

        const contentClassNames = [
            'relative',
            'z-20',
            'flex',
            'justify-end',
            'h-full',
            'translate-x-full',
            'pointer-events-none',
            '[&>div]:pointer-events-auto',
            'transition-all',
            'duration-500',
            'ease-[cubic-bezier(.32,.72,0,1)]',
            'group-[.-active]:translate-x-0',
            ...(this.options.contentClassNames || []),
        ];

        this.content = document.createElement('div');
        this.content.classList.add(...contentClassNames);
        this.root.appendChild(this.content);

        document.body.appendChild(this.root);
    };

    open = () => {
        this.root.classList.add('-active');

        if (this.options.lockScroll) {
            Sidebar.lockPageScroll();
        }
    };

    close = () => {
        this.root.classList.remove('-active');

        if (this.options.lockScroll) {
            Sidebar.unlockPageScroll();
        }
    };

    events = () => {
        this.overlay.addEventListener('click', this.close.bind(this));

        window.addEventListener('click', e => {
            const closeTrigger = e.target.closest('[js-close-sidebar]');

            if (closeTrigger && this.root.contains(closeTrigger)) {
                this.close();
            }
        });
    };
}
